const MemberCard = ({ name, profilePic, circleName = "My Circle", isSelected, onClick }) => {
  return (
    <div className="flex items-center justify-between p-3">
      <div className="flex items-center gap-3 cursor-pointer" onClick={onClick}>
        <img
          src={profilePic}
          alt={name}
          className={`w-10 h-10 rounded-full border-2 object-cover transition-colors ${
            isSelected ? "border-[#F8BA34]" : "border-[#a3a3a3]"
          }`}
        />
        <div>
          <h3 className="font-semibold text-white">{name}</h3>
        </div>
      </div>

      <input
        type="checkbox"
        checked={isSelected}
        onChange={onClick}
        className="w-5 h-5 rounded-full border-2 border-[#a3a3a3] cursor-pointer checked:bg-[#F8BA34] checked:border-[#F8BA34]"
      />
    </div>
  );
};

export default MemberCard;
